import React from 'react';
import { shape, number, bool } from 'prop-types';
import { Typography, Tooltip } from '@one-thd/sui-atomic-components';
import { SpecialSavings } from '@one-thd/sui-icons';
import { TOOLTIP_VIEW_DETAILS } from '../../constants/index';
import { formatPrice } from '../../utils/product-bundle-utils';

/**
 * Props
 *
 * @typedef {object} Props
 * @property {array} priceAdjustment An object of Adjusted Pricing
 * @property {bool} showBundleSavings A bool to show svaings
 */

/**
 * Returns The Delivery Fee and Tax Line Items based on several conditions.
 * @param {Props} Props
 * @returns {React.ReactElement} JSX
 */

const AdditionalSavingsContent = ({ priceAdjustment, showBundleSavings }) => {

  const promos = showBundleSavings ? Object.values(priceAdjustment?.bundleSavingsByPromos)
    : [
      {
        promoId: 0,
        savings: priceAdjustment?.bundleSavings,
        shortDesc: 'Bundle Savings'
      }
    ];

  return (
    <div>
      <Typography variant="body-base" weight="bold">Additional Savings</Typography>
      {promos.map((promo) => (
        <div key={promo.promoId} className="sui-flex sui-flex-row sui-justify-between sui-mt-2">
          <div className="sui-flex sui-gap-1 sui-items-baseline">
            <SpecialSavings size="small" color="success" />
            <div className="sui-flex-1">
              <Typography variant="body-base" color="success">
                {promo.shortDesc}
              </Typography>
            </div>
            {promo?.longDesc
              && (
                <Tooltip offset="normal" title={promo?.longDesc}>
                  <Typography
                    variant="body-xs"
                    decoration="underline"
                    data-testid="bundle-view-details"
                  >
                    {TOOLTIP_VIEW_DETAILS}
                  </Typography>
                </Tooltip>
              )}
          </div>
          <Typography variant="body-base" color="success" data-testid="bundle-savings-amount">
            -{formatPrice(promo.savings)}
          </Typography>
        </div>
      ))}
    </div>
  );
};

AdditionalSavingsContent.propTypes = {
  priceAdjustment: shape({
    bundleSavingsPercentOff: number,
    bundleSavings: number,
    bundleSavingsByPromos: shape({})
  }).isRequired,
  showBundleSavings: bool
};

AdditionalSavingsContent.defaultProps = {
  showBundleSavings: false
};

AdditionalSavingsContent.displayName = 'AdditionalSavingsContent';

export { AdditionalSavingsContent };
